module.exports = __webpack_public_path__ + "static/logo_js_full-91aedf0275e0da633213437cc9cc6225.png";